import { render, staticRenderFns } from "./applyuc.vue?vue&type=template&id=ca8701b2&scoped=true&"
import script from "./applyuc.vue?vue&type=script&lang=js&"
export * from "./applyuc.vue?vue&type=script&lang=js&"
import style0 from "./applyuc.vue?vue&type=style&index=0&id=ca8701b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8701b2",
  null
  
)

export default component.exports